import {
  Clock,
  CreditCard,
  Globe,
  HelpCircle,
  Plane,
  Shield,
  type LucideIcon,
} from "lucide-react";

export type HomeFaqItem = {
  question: string;
  answer: string;
  icon: LucideIcon;
  category: string;
  gradient: string;
  bgColor: string;
};

export const homeFaqs: HomeFaqItem[] = [
  {
    question: "How do I book a flight ticket?",
    answer:
      "Simply search for your destination, select your preferred dates and flight options, fill in passenger details, and complete the payment. You will receive an instant e-ticket confirmation via email and SMS.",
    icon: Plane,
    category: "Booking",
    gradient: "from-sky-500 to-blue-600",
    bgColor: "bg-sky-50 dark:bg-sky-950/20",
  },
  {
    question: "What payment methods do you accept?",
    answer:
      "We accept all major credit/debit cards (Visa, Mastercard, Amex), mobile banking (bKash, Nagad, Rocket), net banking, and various EMI options. All transactions are secured with 256-bit SSL encryption.",
    icon: CreditCard,
    category: "Payment",
    gradient: "from-violet-500 to-purple-600",
    bgColor: "bg-violet-50 dark:bg-violet-950/20",
  },
  {
    question: "Can I cancel or modify my booking?",
    answer:
      "Yes, you can cancel or modify your booking through your account dashboard or by contacting our 24/7 customer support. Cancellation and modification policies vary depending on the airline and fare type.",
    icon: Clock,
    category: "Changes",
    gradient: "from-amber-500 to-orange-600",
    bgColor: "bg-amber-50 dark:bg-amber-950/20",
  },
  {
    question: "Is my personal information secure?",
    answer:
      "Absolutely. We use industry-standard encryption and security protocols to protect your personal and payment information. Our platform is PCI-DSS compliant and regularly audited for security.",
    icon: Shield,
    category: "Security",
    gradient: "from-emerald-500 to-teal-600",
    bgColor: "bg-emerald-50 dark:bg-emerald-950/20",
  },
  {
    question: "Do you offer international flight bookings?",
    answer:
      "Yes, we offer flights to over 200+ destinations worldwide. You can book international flights, multi-city trips, and round-trip journeys with competitive prices and exclusive deals.",
    icon: Globe,
    category: "Services",
    gradient: "from-cyan-500 to-sky-600",
    bgColor: "bg-cyan-50 dark:bg-cyan-950/20",
  },
  {
    question: "How can I get support if I face any issues?",
    answer:
      "Our dedicated customer support team is available 24/7 via phone, email, and live chat. You can also visit our Help Center for instant answers to common questions and self-service options.",
    icon: HelpCircle,
    category: "Support",
    gradient: "from-rose-500 to-pink-600",
    bgColor: "bg-rose-50 dark:bg-rose-950/20",
  },
];
